<template>
   <el-row>
    <el-col>
      <el-breadcrumb separator="/" class="admincrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>店铺</el-breadcrumb-item>
        <el-breadcrumb-item>订单</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col class="'toolbar" style="text-align: right;">
      <el-form :inline="true" :model="sData" size="small" class="form-inline">
        <el-form-item label="订单搜索">
          <el-input size="42" v-model="sData.q" placeholder="请输入订单搜索条件:产品名称,sku,spu,商户spu，订单号,买家姓名等"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="sSubmit"><i class="el-icon-search" style="font-weight: bolder; margin-right: 6px;"></i>订单搜索</el-button>
        </el-form-item>
      </el-form>
    </el-col>
     <el-col>
       <el-table :data="pageinfo.data" @row-click="cellSelect" stripe style="width: 100%">
         <el-table-column prop="orderNo" label="订单号" width="300"></el-table-column>
         <el-table-column prop="orderTime" label="下单时间" :formatter='timeformer' width="220"></el-table-column>
         <el-table-column label="配送地址" width="150">
           <template slot-scope="scope">
             <span v-if="scope.row.buyerAddress.fullName">
               <b>{{ scope.row.buyerAddress.fullName }}</b><br>
               {{ scope.row.buyerAddress.buyerPhone }}<br>
               {{ scope.row.buyerAddress.buyerAddress }}<br/>
               {{ scope.row.buyerAddress.buyerCity }},{{ scope.row.buyerAddress.buyerProvince }}<br/>
               {{ scope.row.buyerAddress.postCode }},{{ scope.row.buyerAddress.country }}
             </span>
             <span v-else>
               当前订单尚在购物车，无配送地址
             </span>
           </template>
         </el-table-column>
         <el-table-column prop="fulfillment" label="配送方式" width="150"></el-table-column>
         <el-table-column prop="Remark" label="备注"></el-table-column>
         <el-table-column prop="Status" label="订单状态" :formatter="orderstatus"></el-table-column>
         <el-table-column fixed="right" label="操作" width="120" align="right">
            <template slot-scope="scope">
              <el-link :href="'/order/detail/' + scope.row.orderNo">订单查看</el-link>
            </template>
          </el-table-column>
      </el-table>
      <el-col :span="24" class="pagenav" style="margin-top: 42px;">
        <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageinfo.page"
        :page-sizes="[15]"
        :page-size="15"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageinfo.total">
        </el-pagination>
      </el-col>
     </el-col>
     <el-dialog :visible.sync="fulfillbox">
       <el-form :model="fulfillbox" ref="carrierForm">
         <el-form-item prop="logistic" label="配送方式">
           <el-input v-model="fulfilldata.logistic" placeholder="请输入配送方式"></el-input>
         </el-form-item>
         <el-form-item prop="tracking" label="物流跟踪号">
           <el-input v-model="fulfilldata.tracking" placeholder="请输入物流跟踪号"></el-input>
         </el-form-item>
         <el-form-item style="text-align: right;">
           <el-button type="primary" size="small"><i class="fa fa-plane"></i>立即发货</el-button>
         </el-form-item>
       </el-form>
     </el-dialog>
   </el-row>
</template>

<script>
export default {
  name: 'Order',
  data () {
    return {
      sData: {},
      currcell: {},
      pageinfo: {page: 0, total: 0, num: 15, data: []},
      fulfillbox: false,
      fulfilldata: {}
    }
  },
  mounted: function () {
    this.handleCurrentChange(1)
  },
  methods: {
    handleCurrentChange: function (page) {
      var params = this.sData
      params['page'] = page
      params['num'] = 15
      params['method'] = 'shop.orderpage'
      var that = this
      this.$http.post(that.$apiurl, params).then(function (ret) {
        that.pageinfo = ret.body.data
      })
    },
    showshipperbox: function (row) {
      var that = this
      this.$set(that.fulfilldata, 'orderId', row.ID)
      that.fulfillbox = true
    },
    cellSelect: function (row, event, column) {
      this.currcell = row
    },
    timeformer: function (v) {
      var d = new Date(v.orderTime)
      return (d.toLocaleString())
    },
    orderstatus: function (v) {
      if (v.Status === 0) {
        return ('pending')
      } else if (v.Status === 1) {
        return ('Shipping Required')
      } else if (v.Status === 200) {
        return ('Shipped')
      } else if (v.Status === 202) {
        return ('Return')
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/order/Order.vue